import ProjectsForm from './ProjectsForm'
import { projectService } from 'src/service/ProjectService';
import { useAuthContext } from 'src/auth/AuthContext';
import { useParams } from 'react-router-dom';
import { useI18n } from '@/i18n/I18nContext';

const ProjectsEdit = () => {
    const { user } = useAuthContext();
    const { t } = useI18n();
    const { id } = useParams();
    const projectId = Number(id);

    return (
        <ProjectsForm projectId={projectId}
            organizationId={user?.data?.organizationId}
            onSubmit={(project) => projectService.update(project)}
            header={t('projects.form.edit')} />
    );
}

export default ProjectsEdit
